import React, { forwardRef } from "react";
import { View, ScrollView } from "react-native";

const CustomContainer = forwardRef(
  ({ scroll, style, contentStyle, children, ...rest }, ref) => {
    if (scroll) {
      return (
        <ScrollView
          ref={ref}
          style={style}
          contentContainerStyle={contentStyle}
          {...rest}
        >
          {children}
        </ScrollView>
      );
    }
    return (
      <View ref={ref} style={[style, contentStyle]} {...rest}>
        {children}
      </View>
    );
  }
);

export default CustomContainer;
